module.exports = __webpack_public_path__ + "img/cas-logo.d5c60139.png";